import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.4 5.873v8.312c.581-.179 1.393-.335 2.45-.335 1.057 0 1.869.156 2.45.335V5.873a3.93 3.93 0 0 0-.288-.11c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.93 3.93 0 0 0-.288.11Zm6.3 0v8.312c.581-.179 1.393-.335 2.45-.335 1.057 0 1.869.156 2.45.335V5.873a3.926 3.926 0 0 0-.288-.11c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.926 3.926 0 0 0-.288.11Zm5.6-.423.405-.57a.7.7 0 0 1 .295.57v9.8a.7.7 0 0 1-1.113.567c-.017-.011-.05-.03-.098-.055a3.417 3.417 0 0 0-.477-.199c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.417 3.417 0 0 0-.477.199 1.614 1.614 0 0 0-.113.064.7.7 0 0 1-.81-.01c-.018-.01-.05-.03-.099-.054a3.42 3.42 0 0 0-.477-.199c-.446-.15-1.157-.313-2.162-.313s-1.716.162-2.162.313a3.42 3.42 0 0 0-.477.199 1.601 1.601 0 0 0-.113.064A.7.7 0 0 1 3 15.25v-9.8a.7.7 0 0 1 .295-.57l.405.57-.405-.57.001-.002h.001l.003-.003.007-.004a1.446 1.446 0 0 1 .074-.048c.045-.027.106-.063.184-.104.157-.08.38-.183.674-.282.59-.2 1.452-.387 2.611-.387 1.159 0 2.022.188 2.61.387.219.074.398.149.54.216.142-.067.322-.142.54-.216.588-.2 1.451-.387 2.61-.387 1.159 0 2.022.188 2.61.387.294.1.518.201.675.282a3.041 3.041 0 0 1 .258.152l.007.004.003.002.002.002-.405.571Zm-.405 10.37v.002-.001Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
